import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Image from "../components/image"
import { Container, Row, Col } from "react-bootstrap"

const h1Style = {
  font: `normal normal 250% Merriweather`,
}

const aboutMeStyle = {
  font: `normal normal 110% Merriweather`,
}

const NameText = () => (
  <Container style={{ marginTop: `8px` }}>
    <Row>
      <Col className="center-block text-center">
        <p
          style={{
            margin: `0`,
            font: `normal bold 150% Merriweather`,
          }}
        >
          Ritesh Kumar
        </p>
        <p
          style={{
            font: `normal bold 100% Gotu`,
            color: `#999`,
            marginBottom: `10px`,
          }}
        >
          Senior Undergraduate, EE & CSE <br /> IIT Kanpur
        </p>
      </Col>
    </Row>
  </Container>
)

const SocialMediaIcons = () => (
  <Container
    style={{
      maxWidth: `240px`,
      marginBottom: `50px`,
    }}
    fluid
  >
    <Row>
      <Col>
        <a href="mailto:ritesh99rakesh@gmail.com">
          <Image name="mail" />
        </a>
      </Col>
      <Col>
        <a href="https://github.com/ritesh99rakesh">
          <Image name="github" />
        </a>
      </Col>
      <Col>
        <a href="https://www.linkedin.com/in/ritesh-kumar-709683146/">
          <Image name="linkedin" />
        </a>
      </Col>
      <Col>
        <a href="https://twitter.com/someone_kumar">
          <Image name="twitter" />
        </a>
      </Col>
    </Row>
  </Container>
)

const Photo = () => (
  <Col lg={4} style={{ marginBottom: `20px` }}>
    <Image name="profile" />
    <NameText />
    <SocialMediaIcons />
  </Col>
)

const AboutMe = () => (
  <Col lg={8}>
    <h1 style={h1Style}>About Me</h1>
    <span style={aboutMeStyle}>
      <p className="text-justify">
        I am a senior undergraduate student at{" "}
        <a href="http://iitk.ac.in/">IIT Kanpur</a>, majoring in Electrical
        Engineering & Computer Science (yes, two majors &#128526;). I am
        interested in problems in{" "}
        <a href="https://github.com/ritesh99rakesh">machine learning</a> and
        algorithms with{" "}
        <a href="https://github.com/ritesh99rakesh">real-world applications</a>.
        <br />
        <br />I love developing and applying machine learning algorithms. I also
        regularly contribute towards Open Source Softwares like{" "}
        <a href="https://www.sympy.org/">SymPy</a>,{" "}
        <a href="https://github.com/TuringLang/Turing.jl">Turing.jl (Julia)</a>{" "}
        and <a href="https://github.com/pymc-devs/pymc">PyMC4</a> and have been
        part of{" "}
        <a href="https://summerofcode.withgoogle.com/archive/2019/projects/5571523094511616/">
          Google Summer of Code 2019
        </a>
        .
        <br />
        <br />
        Currently, I am pursuing a project with{" "}
        <a href="https://www.comp.nus.edu.sg/cs/bio/bhooi/">
          Prof. Bryan Hooi
        </a>{" "}
        at NUS Singapore, where I am working on applications of anomaly
        detection on streaming data with drift change.
        <br />
        <br />
        Prior to this, I have interned at{" "}
        <a href="https://www.uber.com/in/en/">Uber Technologies</a> (Hyderabad)
        as Software Developer, working on pipeline development for anomaly
        detection and root cause analysis for commerce division.
      </p>
    </span>
  </Col>
)

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Container>
      <Row>
        <Photo />
        <AboutMe />
      </Row>
    </Container>
  </Layout>
)

export default IndexPage
